'use client'

import {
  Carousel,
  CarouselApi,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel'
import { CampaignProduct } from '@/types/campaign'
import type { ReactNode } from 'react'
import {
  CampaignProductItem,
  SelectedProductVariantRow,
} from './campaign-product-item'

// Mỗi sản phẩm có thể chọn nhiều tổ hợp màu/size khác nhau (mỗi tổ hợp số
// lượng cố định là 1) - ví dụ Quần Đen-XL và Quần Đen-L là 2 dòng riêng biệt.
export type SelectedProductsMap = Record<string, SelectedProductVariantRow[]>

interface CampaignProductPickerProps {
  title?: ReactNode
  products: readonly CampaignProduct[]
  selectedProducts: SelectedProductsMap
  onAddVariant: (product: CampaignProduct, color: string, size: string) => void
  setApi?: (api: CarouselApi) => void
}

export const CampaignProductPicker = ({
  title,
  products,
  selectedProducts,
  onAddVariant,
  setApi,
}: CampaignProductPickerProps) => {
  return (
    <Carousel
      opts={{
        align: 'start',
        loop: false,
      }}
      setApi={setApi}
      className='w-full'
    >
      {title && (
        <div className='mb-3 flex items-center justify-between gap-2'>
          {title}
          <div className='hidden shrink-0 gap-2 md:flex'>
            <CarouselPrevious
              hideIfStart
              className='static h-9 w-9 translate-x-0 translate-y-0 rounded-full border-none bg-gray-200 text-black hover:bg-gray-300'
            />
            <CarouselNext
              hideIfEnd
              className='static h-9 w-9 translate-x-0 translate-y-0 rounded-full border-none bg-[#111] text-white hover:bg-black/80'
            />
          </div>
        </div>
      )}

      <CarouselContent className='-ml-3'>
        {products.map((product) => (
          <CarouselItem
            key={product.id}
            className='basis-[90%] pl-3 sm:basis-1/2'
          >
            <CampaignProductItem
              product={product}
              selectedRows={selectedProducts[product.id] ?? []}
              onAddVariant={onAddVariant}
            />
          </CarouselItem>
        ))}
      </CarouselContent>

      {!title && (
        <div className='mt-3 hidden justify-end gap-2 md:flex'>
          <CarouselPrevious
            hideIfStart
            className='static h-9 w-9 translate-x-0 translate-y-0 rounded-full border-none bg-gray-200 text-black hover:bg-gray-300'
          />
          <CarouselNext
            hideIfEnd
            className='static h-9 w-9 translate-x-0 translate-y-0 rounded-full border-none bg-[#111] text-white hover:bg-black/80'
          />
        </div>
      )}
    </Carousel>
  )
}
